export const includeSelectedProject = (projects, selectedProject) => {
  if (!selectedProject?.id) return projects || [];

  const currentProjects = projects || [];
  const selectedProjectId = String(selectedProject.id);
  const alreadyIncluded = currentProjects.some(
    (project) => String(project?.id) === selectedProjectId,
  );

  return alreadyIncluded
    ? currentProjects
    : [...currentProjects, selectedProject];
};
